module.exports = __webpack_public_path__ + "img/qb_r.3000a4a7.svg";